export const enum KeywordColorType {
  SECONDARY = 'secondary',
  BLACK = 'black',
}
